export default __webpack_public_path__ + "static/media/030-turn right.c33332ed.png";